// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function memoize<T extends () => Promise<any>>(func: T): T {
  let promise: undefined | ReturnType<T>;
  return async function () {
    if (!promise) {
      promise = func() as ReturnType<T>;
      promise!.then(() => (promise = undefined));
    }
    return promise!;
  } as T;
}
